export default "__VITE_ASSET__80548b85__"